<template>
  <el-select
    :disabled = "disabled"
    filterable
    remote
    v-model="line"
    :remote-method="loadQueryList"
    placeholder="输入线路名称"
    @change="onChange"
    multiple
    clearable
    :style="css">
    <el-option v-for="(item, i) in queryList"
      :key="item.autoLineId"
      :label="item.diyLabel"
      :value="item.autoLineId" />
  </el-select>
</template>

<script>
export default {
  name: "LineSearch",

  props: ["css", 'value', 'disabled'],

  data() {
    return {
      line: null,
      queryList: []
    };
  },

  watch: {
    value(val) {
      let v1 = val && (typeof val !== 'string') ? JSON.stringify(val) : val
      let v2 = this.line ? JSON.stringify(this.line) : this.line
      if (v1 != v2) {
        this.loadValue(this.value);
      }
    }
  },

  methods: {
    loadValue( _id ) {
      var _this = this;
      if ( !_id || _id == "" || !_id.length ) {
        this.line = null;
        return;
      }
      try {
        _id = JSON.parse(_id)
      } catch(e) {}

      _this.queryList = []
      _this.line = Array.isArray(_id) ? _id: [_id];
      for (var i = 0; i < _id.length; i++) {
        sdk.TicketLineApi().getCallLineIndex({
          id : _id[i]
        }).then(res => {
          res.diyLabel = _this.labelStr(res)
          _this.queryList.push(res);
        });
      }
    },

    // http://s.itaojin.cn/merchant/manage/getMerchantUserByNameOrCode
    loadQueryList( _query ) {
      var _this = this;
      if (!_query) {
        return
      }
      sdk.TicketLineApi().findCallLineIndexList({
        lineName: _query
      }).then(res => {
        if(!!res) {
          for (var i = 0; i < res.length; i++) {
            res[i].diyLabel = _this.labelStr(res[i])
          }
          _this.queryList = res;
        }
      });
    },

    labelStr(item) {
      let timeStr1 = (item.callStartDate || item.callEndDate) ? `${item.callStartDate || ''}-${item.callEndDate || ''}` : ''
      let timeStr2 = (item.callStartDate2 || item.callEndDate2) ? `${item.callStartDate2 || ''}-${item.callEndDate2 || ''}` : ''
      let tempArr = []
      if (timeStr1) {
        tempArr.push(timeStr1)
      }
      if (timeStr2) {
        tempArr.push(timeStr2)
      }
      let timeStr = tempArr.join('/')
      return `${item.lineName}(并发:${item.sharedConcurrent || 0}, 盲区:${item.blindAreaProvince || ''}, 呼叫时间范围:${timeStr}, 接通率:${item.callOutThroughRate || ''})`
    },

    onChange(val) {
      this.$emit('input', val);
      this.$emit("change", {'_type': 'line', '_id': val});
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ticket/LineSearch.vue